<div class="header-bar">
  <h1>Tagging Admin</h1>
</div>
<div class="content-container">
  <div class="grid-container filterPanel">
    <div class="grid-item-tag-name">
      <input type="text" pInputText placeholder="Enter Tag Name" [(ngModel)]="tagName" />
    </div>
    <div class="grid-item-tag-desc">
      <textarea
        pInputTextarea
        [rows]="3"
        [cols]="80"
        [(ngModel)]="tagDescription"
        [maxlength]="2048"
        style="width: 100%"
        placeholder="Add tag reasoning/notes"
      ></textarea>
    </div>
    <div class="grid-item-tag-buttons">
      <button
        pButton
        type="button"
        class="tag-button-add"
        label="Add Tag"
        (click)="addTag()"
        [disabled]="!tagName"
      ></button>
      <button
        pButton
        type="button"
        class="tag-button-update"
        label="Update Tag"
        (click)="updateTag()"
        [disabled]="editedTag == null || !tagName"
        [ngClass]="{ 'update-tag-button-color': editedTag != null }"
      ></button>
    </div>
  </div>

  <div class="tags-view">
    <p-dataView [value]="tags" layout="grid">
      <ng-template let-tag pTemplate="gridItem">
        <div style="padding: 0.5em" class="ui-g-12 ui-md-3">
          <h3 class="tag-name">{{ tag.name }}</h3>
          <div class="tag-container">
            <div
              pTooltip="Switch Tag state between active and inactive"
              [ngClass]="{
                'tag-active': tag.inactiveDate == null,
                'tag-inactive': tag.inactiveDate != null
              }"
              (click)="alterActiveState(tag)"
            >
              {{ tag.inactiveDate == null ? 'Active' : 'Inactive' }}
              <span
                [ngClass]="{
                  'pi-lock': tag.inactiveDate == null,
                  'pi-unlock lock-icon-white': tag.inactiveDate != null
                }"
                class="pi lock-icon"
              ></span>
            </div>
            <div class="tag-description">{{ tag.description }}</div>
            <hr class="ui-widget-content" style="border-top: 0" />
            <button
              *ngIf="editedTag != tag"
              pButton
              type="button"
              icon="pi pi-pencil"
              (click)="editTag(tag)"
              class="tag-button-edit"
              pTooltip="Edit Tag"
              [ngClass]="{ 'tag-edit-highlight': editedTag == tag }"
            ></button>
            <button
              *ngIf="editedTag == tag"
              pButton
              type="button"
              icon="pi pi-pencil"
              (click)="editTag(tag)"
              class="tag-button-edit"
              pTooltip="Cancel Edit"
              [ngClass]="{ 'tag-edit-highlight': editedTag == tag }"
            ></button>
            <button
              pButton
              type="button"
              icon="pi pi-times"
              (click)="deleteTag(tag)"
              class="tag-button-delete"
              pTooltip="Delete Tag"
            ></button>
          </div>

          <!--<p-panel [header]="tag.name" [style]="{'text-align':'center'}">
                        <div pTooltip="Switch Tag state between active and inactive"
                             [ngClass]="{'tag-active': tag.inactiveDate == null, 'tag-inactive': tag.inactiveDate != null}"
                             (click)="alterActiveState(tag)">
                            {{ tag.inactiveDate == null ? 'Active' : 'Inactive' }}
                            <span [ngClass]="{'pi-lock': tag.inactiveDate == null, 'pi-unlock lock-icon-white': tag.inactiveDate != null}" 
                                  class="pi lock-icon"></span>
                        </div>
                        <div class="tag-description">{{tag.description}}</div>
                        <hr class="ui-widget-content" style="border-top:0">
                        <button *ngIf="editedTag != tag" pButton type="button" icon="pi pi-pencil" (click)="editTag(tag)"
                                class="tag-button-edit" pTooltip="Edit Tag" [ngClass]="{'tag-edit-highlight': editedTag == tag}">
                        </button>
                        <button *ngIf="editedTag == tag" pButton type="button" icon="pi pi-pencil" (click)="editTag(tag)"
                                class="tag-button-edit" pTooltip="Cancel Edit" [ngClass]="{'tag-edit-highlight': editedTag == tag}">
                        </button>
                        <button pButton type="button" icon="pi pi-times" (click)="deleteTag(tag)" class="tag-button-delete" pTooltip="Delete Tag"></button>
                    </p-panel>-->
        </div>
      </ng-template>
    </p-dataView>
  </div>

  <p-dialog
    header="Delete Tag"
    [(visible)]="showDeleteTagDialog"
    modal="modal"
    [style]="{ width: '300px' }"
    [responsive]="true"
  >
    <form #confirmationNotesForm="ngForm">
      <div class="ui-grid-row" style="margin-bottom: 20px">
        <div class="ui-g-12">This action will delete the specified Tag, ok to continue?<br /></div>
      </div>
      <div class="ui-grid-row" style="float: right">
        <button
          type="button"
          class="green-btn"
          pButton
          icon="fa ui-icon-check"
          (click)="acceptDeleteTag()"
          label="Continue"
        ></button>
        <button
          type="button"
          pButton
          icon="fa ui-icon-close"
          label="Cancel"
          (click)="cancelDeleteTag()"
        ></button>
      </div>
    </form>
  </p-dialog>
</div>
